// extracted by mini-css-extract-plugin
module.exports = {"root":"LandownerReferral_root__2hQ_q","lastUpdated":"LandownerReferral_lastUpdated__18jm7","disc":"LandownerReferral_disc__1QevY"};